import { SkillGroup } from '../types/content';

export const skillGroups: SkillGroup[] = [
  {
    category: 'Energy Transition & Grid Strategy',
    skills: [
      'Renewable Program Design',
      'Utility Rate Structures',
      'Power Missouri Growth Plan',
      'Decarbonization Strategy',
      'Solar Subscription Portfolios'
    ]
  },
  {
    category: 'Corporate Innovation & Venture Growth',
    skills: [
      'Portfolio Management',
      'R&D Investment Evaluation',
      'Start-up Acceleration',
      'Incubatenergy Labs',
      'Energy Impact Partners Deal-Flow'
    ]
  },
  {
    category: 'Regulatory & Governance Alignment',
    skills: [
      'Regulatory Filings Support',
      'C-Suite Capital Allocation',
      'Industry Committee Leadership',
      'Policy Analysis',
      'Stakeholder Management'
    ]
  },
  {
    category: 'Financial & Analytical Strategy',
    skills: [
      'ROI Modeling',
      'Business Case Development',
      'KPI Frameworks',
      'Market Intelligence',
      'Quantitative Analysis'
    ]
  }
];
